import { stats } from '@fiverr-private/obs';
import { STATS_PREFIX } from '../constants';

export const metric = stats.prefix(STATS_PREFIX);
export const count = (metric: string) => stats.count(STATS_PREFIX, metric);
